import { useState } from "react";
import { X } from "lucide-react";
import { Input } from "@/components/ui/input";

// Dialogs call this from onEscapeKeyDown so Escape only closes an open suggestion list
export const keepOpenForChips = (e) => { if (document.activeElement?.closest("[data-chip-open='true']")) e.preventDefault(); };

// Free-typed chips with optional suggestions; no repeats (case-insensitive)
export const ChipInput = ({ values, onChange, placeholder, suggestions = [], testId, tone = "border-line2 bg-veil/[0.03] text-slate-300" }) => {
  const [v, setV] = useState("");
  const [focus, setFocus] = useState(false);
  const [show, setShow] = useState(true);
  const has = (t) => values.some((x) => x.toLowerCase() === t.toLowerCase());
  const add = (raw) => {
    const t = (raw ?? v).trim().replace(/,$/, "");
    if (t && !has(t)) onChange([...values, t]);
    setV("");
    setShow(false);
  };
  const q = v.trim().toLowerCase();
  const opts = focus && show ? suggestions.filter((s) => !has(s) && (!q || s.toLowerCase().includes(q))).slice(0, 8) : [];
  return (
    <div className="space-y-2">
      {values.length > 0 && (
        <div className="flex flex-wrap gap-1.5" data-testid={`${testId}-chips`}>
          {values.map((t) => (
            <span key={t.toLowerCase()} className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs ${tone}`}>
              {t}<button type="button" onClick={() => onChange(values.filter((x) => x !== t))} className="opacity-60 hover:opacity-100 hover:text-rose-300" data-testid={`${testId}-remove-${t}`}><X className="w-3 h-3" /></button>
            </span>
          ))}
        </div>
      )}
      <div className="relative" data-chip-open={opts.length > 0 ? "true" : undefined}>
        <Input value={v} maxLength={100} onChange={(e) => { setV(e.target.value); setShow(true); }} placeholder={placeholder} onFocus={() => { setFocus(true); setShow(true); }}
          onBlur={() => setTimeout(() => { setFocus(false); add(); }, 150)}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(); } else if (e.key === "Escape" && opts.length) { e.preventDefault(); setShow(false); } }} data-testid={`${testId}-input`} />
        {opts.length > 0 && (
          <div className="absolute z-30 left-0 right-0 top-full mt-1 rounded-lg border border-line bg-panel shadow-xl py-1 max-h-56 overflow-y-auto" data-testid={`${testId}-suggest`}>
            {opts.map((s, i) => (
              <button key={s} type="button" onMouseDown={(e) => { e.preventDefault(); add(s); }} className="block w-full text-left px-3 py-1.5 text-sm text-slate-300 hover:bg-amber-500/10 hover:text-amber-200" data-testid={`${testId}-option-${i}`}>{s}</button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
